const findDomElement = ({ element, targetName }) => 
{
    let result = null;
    if (element?.name === targetName) 
    {
        return element;
    }

    if (element?.children !== null) 
    {
        element?.children?.forEach((child) => 
        {
            if (!result) 
            {
                result = findDomElement({ element: child, targetName });
            }
        });
    }
    return result;
}

export const findDomElements = ({ element, targetName }) =>
{
    let results = [];
    if (element?.name === targetName)
    {
        results.push(element);
    }

    if (element?.children !== null)
    {
        element?.children?.forEach((child) =>
        {
            results = results.concat(findDomElements({ element: child, targetName }));
        });
    }

    return results;
};

export const findDomElementFilterFn = ({ element, filterFn }) => 
{
    let result = null;
    if (filterFn(element)) 
    {
        return element;
    }

    if (element?.children !== null) 
    {
        element?.children?.forEach((child) => 
        {
            if (!result)
            {
                result = findDomElementFilterFn({ element: child, filterFn });
            }
        });
    }
    return result;
}

export default findDomElement;